export default function UserModel() {
  function User() {
    this.id = '';
    this.login = '';
    this.password = '';
    this.isUserEnabled = '';
    this.createdAt = '';
    this.roles = [];
  }

  return User;
}



// WEBPACK FOOTER //
// ./src/app/users/user.model.js